import { Schema } from "mongoose"
import { z } from "zod"

import type { AclPolicy } from "../acl"
import { ZRBNotificationPlatformPayload } from "./RBNotification"


const ZStringMap = z.record(z.string(), z.string())

export const ZRBNotificationDelivery = z.object({
  userId: z.string(),
  notificationId: z.string().optional(),
  deliveryId: z.string(),
  topic: z.string().optional(),
  tag: z.string().optional(),
  title: z.string(),
  body: z.string().optional(),
  image: z.string().optional(),
  data: ZStringMap.optional(),
  platform: ZRBNotificationPlatformPayload.optional(),
  createdAt: z.date(),
})

export type IRBNotificationDelivery = z.infer<typeof ZRBNotificationDelivery>

const TTL_90_DAYS_S = 60 * 60 * 24 * 90

export const RBNotificationDeliverySchema: Schema = new Schema(
  {
    userId: { type: String, required: true, index: true },
    notificationId: { type: String, required: false },
    deliveryId: { type: String, required: true, unique: true },
    topic: { type: String, required: false },
    tag: { type: String, required: false },
    title: { type: String, required: true },
    body: { type: String, required: false },
    image: { type: String, required: false },
    data: { type: Schema.Types.Mixed, required: false },
    platform: { type: Schema.Types.Mixed, required: false },
    createdAt: { type: Date, required: true, default: Date.now },
  },
  {
    versionKey: false,
  },
)

RBNotificationDeliverySchema.index({ userId: 1, createdAt: -1 })
RBNotificationDeliverySchema.index({ createdAt: 1 }, { expireAfterSeconds: TTL_90_DAYS_S })

export const RBNotificationDeliveryPolicy: AclPolicy = {
  subject: "RBNotificationDelivery",
  define: (builder, ctx) => {
    if (!ctx.userId) return
    builder.can("create", "RBNotificationDelivery")
    builder.can("read", "RBNotificationDelivery", { userId: ctx.userId })
  },
}
